import axios, { AxiosResponse } from "axios";
import { baseUrl } from "./baseUrl";

export const getApi = async <T, P = Record<string, any>>(
  url: string,
  params?: P,
): Promise<AxiosResponse<T>> => {
  const response = await axios.get<T>(`${baseUrl}${url}`, { params });
  return response;
};

export const postApi = async <T, O>(
  url: string,
  payload?: O,
): Promise<AxiosResponse<T, O>> => {
  const response = await axios.post<T>(`${baseUrl}${url}`, payload);
  return response;
};

export const putApi = async <T, O>(
  url: string,
  payload?: O,
): Promise<AxiosResponse<T, O>> => {
  const response = await axios.put<T>(`${baseUrl}${url}`, payload);
  return response;
};
